const FixedTop = () => (
  <div className="fixed-top-wrapper">
    <div className="fixed-top text-white">
      <div className="container text-center text-uppercase">
        The competition has ended. Thank you to all who participated and we'll see you on the next
        Race to Gem Mountain!
      </div>
    </div>
  </div>
);

export default FixedTop;
